/**
 * The player's explicit high-contrast choice, or `null` to follow the OS.
 * The settings breaker overrides either way (STYLEGUIDE §12) — a player
 * whose OS "Increase Contrast" is really about other apps can turn it off
 * here, and one whose OS never asked can turn it on.
 */
let override: boolean | null = null;

function osPrefersContrast(): boolean {
  return globalThis.matchMedia?.('(prefers-contrast: more)').matches ?? false;
}

/** Should the stylesheet run in high-contrast mode? */
export function prefersContrast(): boolean {
  return override ?? osPrefersContrast();
}

export function setContrastOverride(value: boolean | null): void {
  override = value;
  syncContrastAttr();
}

/**
 * Keep the stylesheet's flag in step with the effective preference. CSS keys
 * off this one attribute rather than the media query, so the settings switch
 * can also *turn off* HC when the OS asked for it (and vice versa).
 */
export function syncContrastAttr(): void {
  document.documentElement.toggleAttribute('data-contrast', prefersContrast());
}
